export function loadBrowserPolyfillsIfNeeded(polyfillRelativeTime) {
  var polyfillPromises = [];

  if (polyfillRelativeTime && typeof Intl.RelativeTimeFormat === 'undefined') {
    polyfillPromises.push(import('@formatjs/intl-relativetimeformat/polyfill-locales'
    /* webpackChunkName: "wix-i18n-config_intl-relativetimeformat" */
    ));
  }

  if (typeof Intl.PluralRules === 'undefined') {
    polyfillPromises.push(import('@formatjs/intl-pluralrules/polyfill-locales'
    /* webpackChunkName: "wix-i18n-config_intl-pluralrules" */
    ));
  }

  if (polyfillPromises.length > 0) {
    var promise = Promise.all(polyfillPromises);
    var response = {
      isLoading: true,
      promise: promise
    };
    promise.then(function () {
      response.isLoading = false;
    })["catch"](function () {
      response.isLoading = false;
    });
    return response;
  }

  return {
    isLoading: false
  };
}